export const ViewInvoiceQuery = `
  query ($id: Int!) {
    invoice_multiorder(id_multi_order: $id) {
      id_usuario
      status
      id_factura
      id_datos_fac
      pedidos {
          id_pedido
          id_estado_pd
          cod_pedido
          lines {
            cantidad
            nombre
          }
          foto_direccion {
            linea1
            linea2
            linea3
          }
      }
    }
  }
`

export const ViewUserQuery = `
  query ($id: Int!) {
    user(id_usuario: $id) {
      email,
      datos_fac {
        id_datos_fac,
        nombre,
        linea1,
        linea2,
        linea3
      }
    }
  }
`

export const RemoveOrderMutation = `
  mutation($id: Int!, $orderIds: [Int!]) {
    invoice_multiorder_update(
        input: { 
          id: $id,
          remove_orders: $orderIds,
        }
    ) {
        status
    }
  }
`

export const SetInvoicedMutation = `
  mutation($id: Int!) {
    invoice_multiorder_set_invoiced(
      id_multiorder: $id
  ) {
      status
    }
  }
`

export const SelectBillingAddressMutation = `
  mutation($id: Int!, $id_fac: Int!) {
    invoice_multiorder_update(
      input: {
        id: $id,
        id_datos_fac: $id_fac
      }
  ) {
      status
    }
  }
`

export const HibernateMutation = `
  mutation($orderIds: [Int!], $date: Datetime) {
    batch_pedido_hibernate(
      pedidos: $orderIds
      date: $date
    ) {
      status,
      errors
    }
  }
`

export const ConfirmOrdersMutation = `
  mutation($orderIds: [Int!]) {
    batch_pedido_confirm_payment(
      pedidos: $orderIds
    ) {
      status, errors
    }
  }
`

export const CancelOrdersMutation = `
  mutation($orderIds: [Int!]) {
    batch_pedido_cancel(
      pedidos: $orderIds
    ) {
      status, errors
    }
  }
`

export const CommentOrdersMutation = `
  mutation($orderIds: [Int!], $comment: String!, $type: PedidoTipoObservaciones) {
    batch_pedido_addcomment(
      pedidos: $orderIds
      comment: $comment
      tipo: $type
      ) {
      status, errors
    }
  }
`

export const CreateAddressMutation = `
  mutation(
    $userId: Int!, 
    $nombre: String!, 
    $doc_id: String!, 
    $linea1: String!, 
    $linea2: String, 
    $linea3: String, 
    $codigo_postal: String!, 
    $ciudad: String!, 
    $telefono: String!, 
    $id_pais: String!
  ) {
    user_add_datos_fac(
        input: { 
          id_usuario: $userId,
          nombre: $nombre,
          doc_id: $doc_id,
          linea1: $linea1,
          linea2: $linea2,
          linea3: $linea3,
          codigo_postal: $codigo_postal,
          ciudad: $ciudad,
          telefono: $telefono,
          id_pais: $id_pais,
        }
    ) {
      id_datos_fac
    }
  }
`

export const ListInvoicesQuery = `
  query($user: Int, $page: Int) {
    invoice_multiorder_search(id_usuario: $user, page: $page) {
      data {
        id,
        id_factura,
        id_usuario,
        email,
        nombre,
        status,
        id_pedidos
      }
      amount,
      current_page
    }
  }
`

export const CreateInvoiceMutation = `
  mutation($id_usuario: Int!) {
    invoice_multiorder_create(
        input: { id_usuario: $id_usuario }
    ) {
        status
    }
  }
`

export const CreateOrderInvoice = `
  mutation(
    $id: Int!, $tipo_descuento: OrderDiscountType, $descuento: Float,
    $gift_paper:Boolean, $present_message:String, $observaciones: String,
    $products: [input_pedido_linea!]!, $address: [input_foto_direccion!]!
  ) {
    invoice_multiorder_batch_create_orders(input: {
      id: $id,
      order: {
        tipo_descuento: $tipo_descuento,
        descuento: $descuento,
        gift_paper: $gift_paper,
        present_message: $present_message,
        observaciones: $observaciones,
      },
      products: $products,
      address: $address,
  }
  ) {
      status
    }
  }
`
